import { measureLatency } from '../../../../gctl-measure';
import {
  StorageLimitLockingFields,
  StorageLimitLocking,
} from '../../../../models/components/schemas/storage-limit-locking/StorageLimitLocking';
import { Select, NetworkError, deepCamelCase, intoSnakeCase } from '../../../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetUserSettingsBillingStorageLimitLockingFields = readonly StorageLimitLockingFields[];

/** Options for GET /users/{user_id}/settings/billing/storage_limit_locking */
export type GetUserSettingsBillingStorageLimitLockingOptions<Paths extends readonly string[]> =
  Omit<RequestInit, 'method' | 'body'> & {
    baseUrl?: string;

    /** Available fields on the response type, application/json */
    select: Paths;
    where: {
      /**
       * The ID of the user.
       */
      userId: number;
    };
  };

/** Result type for GET /users/{user_id}/settings/billing/storage_limit_locking */
export type GetUserSettingsBillingStorageLimitLockingResult<Paths extends readonly string[]> =
  Select<StorageLimitLocking, Paths>;

/**
 * Get storage-limit locking metadata
 * This method returns storage-limit locking metadata for the specified user.
 */
export async function getUserSettingsBillingStorageLimitLocking<
  Paths extends GetUserSettingsBillingStorageLimitLockingFields,
>({
  baseUrl,
  select,
  where: { userId },
  ...options
}: GetUserSettingsBillingStorageLimitLockingOptions<Paths>): Promise<
  GetUserSettingsBillingStorageLimitLockingResult<Paths>
> {
  return measureLatency('getUserSettingsBillingStorageLimitLocking', 'GET', async () => {
    let res = await fetch(
      `${baseUrl}/users/${userId}/settings/billing/storage_limit_locking?fields=${select
        .map(intoSnakeCase)
        .join(',')}`,
      {
        ...options,
        method: 'GET',
      },
    );

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as GetUserSettingsBillingStorageLimitLockingResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
